
function checkNumber(number) {
    const result = number.replace(/\D/g, '');
    return result
}

export default checkNumber